import type {IAuthor, ISiteNavigation} from '@anywayseo/tools';
import {StaticImage} from 'gatsby-plugin-image';

export const author: IAuthor = {
  name: 'Priya Malhotra',
  role: 'Expert Author',
  bio: "I'm Priya Malhotra, your Plinko expert at online-plinko.games. I've been exploring online gambling since 2017, and I love helping Indian players discover the best Plinko game online platforms and find amazing bonuses. My goal is simple: make plinko game online real money fun, safe, and profitable for everyone in India!",
  avatar: <StaticImage src={'./assets/priya-malhotra-foto.jpg'} alt='Priya Malhotra' style={{ borderRadius: '50%' }} />,
};

export const localNavigation: ISiteNavigation = {
  header: {},
  footer: {
    en: [
      { slug: 'privacy-policy', label: 'Privacy Policy' },
      { slug: 'cookie-policy', label: 'Cookie Policy' },
      { slug: 'terms-and-conditions', label: 'Terms & Conditions' },
      { slug: 'contacts', label: 'Contacts' },
    ],
  },
};
